// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestion-wrapper":"QLlHG","assistance-container":"oKETl","helpWrapper":"K-fgx","assistance-list":"L9UKW","noSearchResultsPageSearch":"B9Bh0"};